<template>
  <div class="d-flex flex-fill flex-column">
    <div class="d-flex flex-fill border border-top-0">
      <div class="textTitle d-flex"><span>折扣優惠</span></div>
      <div class="d-flex flex-fill flex-column text-left">
        <div class="d-flex flex-column p-3 border">
          <betweenPrice :baseData='baseData' :thdata='thdata' :nosave='true'
            @btnsave='saveperiod' />
         
          <div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" value='1' :checked='thdata.showoff==1'
                @input='changeinput("showoff",thdata.showoff==1?0:1)' id="costDiscount" />
              <label class="form-check-label" for="costDiscount">是否顯示折扣多少</label>
            </div>
          </div>
        </div>
        <div class="d-flex align-items-center border border-top-0 p-3">
          <span>【買滿折扣】</span>
          <div class="form-check">
            <input class="form-check-input" type="checkbox" value='1'
              :checked='thdata.buyfulloff.check==1'
              @input="changeinput('check',thdata.buyfulloff.check==1?0:1,'buyfulloff')"
              id='costBuyFull' />
            <label class="form-check-label" for="costBuyFull">買滿</label>
          </div>
          <div style="width:70px;">
            <b-input :disabled='thdata.buyfulloff.check!=1' :value='thdata.buyfulloff.number'
              type='number' class='text-right' @input='changeinput("number",$event,"buyfulloff")'>
            </b-input>
          </div>
          <span>件再</span>
          <div>
            <b-form-select class="custom-select" :value="thdata.buyfulloff.method"
              @input='changeinput("method",$event,"buyfulloff")'
              :disabled='thdata.buyfulloff.check!=1'>
              <option value='off'>折價</option>
              <option value='pa'>打折</option>
            </b-form-select>
          </div>
          <div style="width:80px;">
            <b-input :value='thdata.buyfulloff.offmoney' type='number' class='text-right'
              :disabled='thdata.buyfulloff.check!=1'
              @input='changeinput("offmoney",$event,"buyfulloff")'></b-input>
          </div>
          <span>{{thdata.buyfulloff.method=="off"?"元":"%"}}</span>
        </div>
        <div class="d-flex border border-top-0 border-bottom-0 p-3">
          <div>【再折扣】</div>
          <div class="d-flex flex-column pl-3">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" value id="costLimitBuy"
                :checked='thdata.aginoffrule.indexOf("costLimitBuy")>-1'
                @input="changeinputpush('aginoffrule','costLimitBuy')" />
              <label class="form-check-label" for="costLimitBuy">限制會員購買</label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" value id="costNotDis"
                :checked='thdata.aginoffrule.indexOf("costNotDis")>-1'
                @input="changeinputpush('aginoffrule','costNotDis')" />
              <label class="form-check-label" for="costNotDis">
                不適用任何折扣
                <sup>?</sup>
              </label>
            </div>
          </div>
          <div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" value id="costAgainDis"
                :checked='thdata.aginoffrule.indexOf("costAgainDis")>-1'
                @input="changeinputpush('aginoffrule','costAgainDis')" />
              <label class="form-check-label" for="costAgainDis">
                允許買滿件數後，
                <u>總價再折扣</u>
                <sup>?</sup>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex flex-fill border border-top-0 border-bottom-0">
      <div class="textTitle d-flex border-right">加購設定</div>
      <div class="d-flex flex-wrap w-100">
        <div class="d-flex flex-column flex-fill justify-content-around p-3">
          <div class="d-flex justify-content-start align-items-center">
            <span>本商品加購分類為</span>
            <div class>
              <b-select class="form-control" :value='thdata.setAddClass.Class'
                @input='changeinput("Class",$event,"setAddClass")'>
                <option value=''>無標籤</option>
                <option v-for='item in addClass' :key='"AA__"+item.value' :value='item.value'>
                  {{item.name}}</option>
              </b-select>
            </div>
            <span>區</span>
          </div>
          <div class="d-flex flex-column align-items-start">
            <div>
              <div class="form-check">
                <input class="form-check-input" type="checkbox"
                  @input='changeinput("showaddPro",thdata.setAddClass.showaddPro==1?0:1,"setAddClass")'
                  :checked='thdata.setAddClass.showaddPro==1' id="cosBuyExtra" />
                <label class="form-check-label" for="cosBuyExtra">成為加購選項：購買時秀出加購項目</label>
              </div>

            </div>
          </div>
        </div>
        <div class="d-flex ml-auto" v-if='thdata.setAddClass.Class'>
          <table class="table table-bordered m-0">
            <caption class='text-left'>
              <span class='text-info'>
                {{getListname(addClass,{value:thdata.setAddClass.Class})}}
              </span>
              <small>
                區，相關加購優惠
              </small>
            </caption>
            <thead align="left">
              <tr>
                <th style='width:30px'></th>
                <th>搭配分類</th>
                <th>折價方式</th>
                <th>折價數字</th>
                <th>此單價金額</th>
              </tr>
            </thead>
            <tbody align="left">
              <tr v-for='(item,$index) in offclasslist'>
                <th>{{$index+1}}</th>
                <td>{{item.matchclass}}</td>
                <td>{{getListdata(costmethod,{value:item.offmethod}).name}}</td>
                <td class='text-right'>
                  {{item.offnumber}}{{getListdata(costmethod,{value:item.offmethod}).aftername}}
                </td>
                <td class='text-right'>
                  {{computemoney(baseData.price.sell,item.offnumber,getListdata(costmethod,{value:item.offmethod}).value=='discash'?'-':"%")|currency}}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="d-flex flex-fill border">
      <div class="textTitle d-flex">運費設定</div>
      <div class="d-flex flex-fill flex-column text-left">
        <div class="d-flex flex-column p-3 border border-top-0">
          <div class='w-100 d-flex flex-wrap flex-md-row flex-sm-column'>
            <div>
              <b-card class="mb-2 h-100">
                <template #header>
                  <h6>
                    <div class="d-flex">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" value id="cosAll"
                          @change='allcheckbox("freightdata.method",freightlist,$event)' />
                        <label class="form-check-label" for="cosAll">全選</label>
                      </div>
                      <span class="pl-2">運送方式</span>
                    </div>
                  </h6>
                </template>
                <div class="d-flex flex-column">
                  <div class="d-flex justify-content-between align-items-center mt-1"
                    v-for='item in freightlist'>
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" value :id="'SSA__'+item.value"
                        :checked='thdata.freightdata.method.indexOf(item.value)>-1'
                        @input='changeinputpush("method",item.value,"freightdata")' />
                      <label class="form-check-label"
                        :for="'SSA__'+item.value">{{item.name}}</label>
                    </div>
                    <div v-if='item.setting' class='ml-5' style='width:120px;'>
                      <b-input-group prepend="＄" class="mb-2 mr-sm-2 mb-sm-0">
                        <b-input type='number' class='text-right'
                          :disabled='!thdata.freightdata.method.indexOf(item.value)>-1'
                          :value='thdata.freightdata[item.setting.field]'
                          @input='changeinput(item.setting.field,$event,"freightdata")'>
                        </b-input>
                      </b-input-group>
                    </div>
                  </div>
                </div>
              </b-card>
            </div>
            <div class='ml-5'>
              <b-card class="mb-2 h-100">
                <template #header>
                  <h6>
                    <div class="d-flex">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" id="cosAll2"
                          @change='allcheckbox("paydata.method",paymethodlist,$event)' />
                        <label class="form-check-label" for="cosAll2">全選</label>
                      </div>
                      <span class="pl-2">付款方式</span>
                    </div>
                  </h6>
                </template>
                <div class="d-flex flex-column">
                  <div class="d-flex justify-content-between align-items-center mt-1"
                    v-for='item in paymethodlist'>
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" value :id="'SSP__'+item.value"
                        :checked='thdata.paydata.method.indexOf(item.value)>-1'
                        @input='changeinputpush("method",item.value,"paydata")' />
                      <label class="form-check-label"
                        :for="'SSP__'+item.value">{{item.name}}</label>
                    </div>
                    <div class="d-flex align-items-center" v-if='item.setting'>
                      <span>（另收</span>
                      <b-input-group prepend="＄" class="mb-2 mr-sm-2 mb-sm-0" style="width:120px">
                        <b-input type='number' class='text-right'
                          :disabled='!thdata.paydata.method.indexOf(item.value)>-1'
                          :value='thdata.paydata[item.setting.field]'
                          @input='changeinput(item.setting.field,$event,"paydata")'>
                        </b-input>
                      </b-input-group>
                      <span>）</span>
                    </div>
                  </div>
                </div>
              </b-card>
            </div>
          </div>
          <div class="d-flex align-items-center mt-2">
            <div class="d-flex align-items-center">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" value id="costShipSetting"
                  :checked='thdata.freightset.doublemoney==1'
                  @change='changeinput("doublemoney",thdata.freightset.doublemoney==1?0:1,"freightset")' />
                <label class="form-check-label" for="costShipSetting">買</label>
              </div>
              <div style="width:70px">
                <b-input type='number' class='text-right' :value='thdata.freightset.doublelimit'
                  @input='changeinput("doublelimit",$event,"freightset")'></b-input>
              </div>
              <span>件以上，運費為兩倍</span>
            </div>
            <div class="d-flex align-items-center ml-4">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" value id="costShipSetting2"
                  :checked='thdata.freightset.buyfullnofre==1'
                  @change='changeinput("buyfullnofre",thdata.freightset.buyfullnofre==1?0:1,"freightset")' />
                <label class="form-check-label" for="costShipSetting2">買滿</label>
              </div>
              <div style="width:70px">
                <b-input type='number' class='text-right' :value='thdata.freightset.buyfullnumber'
                  @input='changeinput("buyfullnumber",$event,"freightset")'></b-input>
              </div>
              <span>件，免運費</span>
            </div>
          </div>
        </div>
        <div class="d-flex flex-column align-items-start border p-3 border-top-0 border-bottom-0">
          <span>【自訂設定】</span>
          <div class="d-flex align-items-center">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" value id="costShipSetting3"
                :checked='thdata.freightset.selectset==1'
                @change='changeinput("selectset",thdata.freightset.selectset==1?0:1,"freightset")' />
              <label class="form-check-label" for="costShipSetting3">指定</label>
            </div>
            <div style="width:50px">
              <b-input class='text-right' :value='thdata.freightset.selectsetfreighmonth'
                @input='changeinput("selectsetfreighmonth",$event,"freightset")'></b-input>
            </div>
            <span>／</span>
            <div style="width:50px">
              <b-input class='text-right' :value='thdata.freightset.selectsetfreighday'
                @input='changeinput("selectsetfreighday",$event,"freightset")'></b-input>
            </div>
            <span>日期以前，只使用</span>
            <div>
              <b-select :value='thdata.freightset.selectsetfreighmethod'
                @input='changeinput("selectsetfreighmethod",$event,"freightset")'>
                <option :value="item.value" v-for='item in freightlist'>
                  {{item.name}}
                </option>
              </b-select>
            </div>
            <span>，顯示自訂名稱</span>
            <div>
              <b-input placeholder="開課當日領取" :value='thdata.freightset.selectsetfreighname'
                @input='changeinput("selectsetfreighname",$event,"freightset")'>
              </b-input>
            </div>
          </div>
          <div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" value id="costShipSetting4"
                :checked='thdata.freightset.noUseWeb==1'
                @change='changeinput("noUseWeb",thdata.freightset.noUseWeb==1?0:1,"freightset")' />
              <label class="form-check-label"
                for="costShipSetting4">不適用網站設定之免運費（購物車滿額／出貨方式／會員等級／指定會員）</label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex flex-fill border">
      <div class="textTitle d-flex">消費者提醒</div>
      <div class="d-flex flex-fill flex-column text-left">
        <div class="d-flex flex-column border p-3 border-top-0 border-bottom-0">
          <div>
            <b-input placeholder="請在此輸入文字" :value='thdata.reminder'
              @input='changeinput("reminder",$event)'></b-input>
          </div>
          <div>
            <ul>
              <li>結帳前須知，例如：『本商品不接受退換貨』</li>
              <li>購物車畫面中會顯示之提示文字</li>
              <li>結帳後同時寫入EMAIL確認訂單信、列印收據等</li>
            </ul>
          </div>
        </div>
      </div>
    </div>

  </div>
  <!-- <div class="costCon d-flex flex-fill justify-content-center">
    <div class="d-flex flex-column">
      <div class="d-flex flex-row h-100 border">
        <div class="d-flex border-right align-items-center tableTitle">是否顯示價格</div>
        <div class="d-flex flex-column text-left flex-fill">
          <b-form-radio v-model="selected" name="some-radios" value="A">A. 會員和非會員均可看到一般價與會員價
          </b-form-radio>
          <div class="d-flex flex-row">
            <b-form-radio v-model="selected" name="some-radios" value="B">B. 會員方可看到會員價
            </b-form-radio>
            <small>( 非會員只可以看到一般價 )</small>
          </div>
          <div class="d-flex flex-row">
            <b-form-radio v-model="selected" name="some-radios" value="C">C. 會員方可看到一般價與會員價
            </b-form-radio>
            <small>( 非會員兩個都看不到 )</small>
          </div>
        </div>
      </div>
      <div class="d-flex flex-row h-100 border">
        <div class="d-flex border-right align-items-center tableTitle">會員方可購買</div>
        <div class="d-flex flex-column text-left">
          <div>
            <b-form-checkbox name="costMemberCheck" v-model="memberCheck" :value="true"
              :unchecked-value="false">會員方可購買</b-form-checkbox>
          </div>
          <div class="d-flex flex-row">
            <div>會員未登入時：</div>
            <div class="d-flex flex-column">
              <b-form-radio name="memberBuyRadio" value>
                顯示
                <strong>訂購鈕</strong>，點了會提示須登入會員方可買
              </b-form-radio>
              <b-form-radio name="memberBuyRadio" value>
                隱藏
                <strong>訂購鈕</strong>
              </b-form-radio>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex flex-row border h-100">
        <div class="d-flex border-right align-items-center tableTitle">商品折扣</div>
        <div class="d-flex flex-column text-left flex-fill">
          <div class="d-flex">
            <div>單品折扣： 或</div>
            <a href @click.prevent>選擇折扣區</a>
            <div>(擇一)</div>
          </div>
          <div class="d-flex flex-row bg-success" style="width:600px">
            <div>買滿</div>
            <div class="d-flex flex-column">
              <b-form-input size="sm"></b-form-input>
              <b-form-input size="sm"></b-form-input>
              <b-form-input size="sm"></b-form-input>
            </div>
            <div>件，每件</div>
            <div>
              <div class="input-group input-group-sm mb-3">
                <select class="custom-select">
                  <option selected>Choose...</option>
                </select>
              </div>
            </div>
            <div class="d-flex flex-column">
              <div class="d-flex align-items-center">
                <select class="custom-select">
                  <option selected>Choose...</option>
                </select>
                <div>折</div>
              </div>
              <div class="d-flex align-items-center">
                <select class="custom-select">
                  <option selected>Choose...</option>
                </select>
                <div>折</div>
              </div>
              <div class="d-flex align-items-center">
                <select class="custom-select">
                  <option selected>Choose...</option>
                </select>
                <div>折</div>
              </div>
            </div>
          </div>
          <div>
            <ul>
              <li>滿件數量由小到大填寫</li>
            </ul>
          </div>
          <div>
            <b-form-checkbox name="onsale" :value="true" :unchecked-value="false">當符合上述滿件打完折後，
              允許總價再折扣<small>(例如：會員等級折扣)</small>
            </b-form-checkbox>
          </div>
          <div>
            <ul>
              <li>若已滿足上述商品折扣條件時：</li>
              <li style="list-style-type:none;">不勾選：總價不再打折，訂單細目顯示 不適用總價再折扣</li>
              <li style="list-style-type:none;">勾選：總價再打折</li>
              <li>未滿足上述商品折扣條件時：總價會再打折</li>
              <li>什麼是 總價再折扣：即訂單最後總計金額再打折 (例如：會員等級折扣)</li>
              <li style="list-style-type:none;">請參考 [購物車設定 / 總價再折扣]</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="d-flex flex-row border h-100">
        <div class="d-flex border-right align-items-center tableTitle">折扣排除</div>
        <div class="d-flex flex-column text-left">
          <b-form-radio name="onsaleRadio" :value="true" v-model="testRadio" @click="aaa()">
            不適用 總價再折扣 <small> (例如：會員等級折扣)</small>
          </b-form-radio>
          <ul>
            <li>本商品一律不允許總價再折扣</li>
            <li>訂單細目顯示 不適用總價再折扣</li>
          </ul>
          <b-form-radio name="onsaleRadio" :value="false" v-model="testRadio" @click="aaa()">
            不適用任何折扣
          </b-form-radio>
          <ul>
            <li>商品折扣 與 總價再折扣 兩者都不允許</li>
            <li>訂單細目顯示 不適用任何折扣</li>
          </ul>
        </div>
      </div>
      <div class="d-flex flex-row border h-100">
        <div class="d-flex border-right align-items-center tableTitle">加購品</div>
        <div class="d-flex flex-column text-left align-items-center">
          <b-form-checkbox name="memBuyOther" :value="true" :unchecked-value="false">加購品
            需與買其他非折扣商品一起購買</b-form-checkbox>
          <div class="d-flex flex-fill align-items-center">
            <b-form-checkbox name="memBuyOtherSingle" :value="true" :unchecked-value="false">
              也可單獨購買，但需另加
            </b-form-checkbox>
            <div class="d-flex align-items-center">
              <b-form-input size="sm" style="width:40px" class=" no-gutters"></b-form-input>元
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex flex-row border h-100">
        <div class="d-flex border-right align-items-center tableTitle">免運設定</div>
        <div class="d-flex flex-column flex-fill align-items-start">
          <div class="d-flex align-items-center">買滿<b-form-input size="sm" style="width:40px"
              class=" no-gutters">
            </b-form-input>件免運費</div>
          <div>
            <b-form-checkbox name="freeCheck" :value="true" :unchecked-value="false">
              本商品獨立計算免運，訂單內若含其他商品，仍需運費</b-form-checkbox>
          </div>
          <div>
            <b-form-checkbox name="freeCheck2" :value="true" :unchecked-value="false">
              不適用滿多少免運費</b-form-checkbox>
          </div>
          <div class="text-left">
            <ul>
              <li>本商品不納入下列四項免運判斷</li>
              <li style="list-style-type:none;">於購物車內 [總體免運] 或某 [貨運方式] 免運設定</li>
              <li style="list-style-type:none;">於 [會員等級] 或 [某位會員] 免運設定</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="d-flex flex-row border h-100">
        <div class="d-flex border-right align-items-center tableTitle">不適用的
          貨運\付款方式</div>
        <div class="d-flex flex-column text-left align-items-center">
        </div>
      </div>
      <div class="d-flex flex-row border h-100">
        <div class="d-flex border-right align-items-center tableTitle">消費提醒 </div>
        <div class="d-flex flex-column text-left flex-fill">
          <b-form-textarea size="sm" style="width:500px">
          </b-form-textarea>
          <ul>
            <li>消費者於購物時於購物車中可看到此文字 例如:『本商品不接受退換貨』( 50 字 )</li>
            <li>此文字會同步寫入到訂單細目的 [消費提醒]中</li>
          </ul>
        </div>
      </div>
    </div>
  </div>-->
</template>
<script>
  import ctrl from "./insCost.js";
  export default ctrl;

</script>
<style lang="scss">
  .textTitle {
    writing-mode: vertical-lr;
    width: 30px;
    align-items: center;
    justify-content: center;
    letter-spacing: 10px;
  }

</style>
